import { render } from "./pluginConfig.vue?vue&type=template&id=4105b4b1&scoped=true&ts=true"
import script from "./pluginConfig.vue?vue&type=script&lang=ts"
export * from "./pluginConfig.vue?vue&type=script&lang=ts"

import "./pluginConfig.vue?vue&type=style&index=0&id=4105b4b1&lang=scss"
import "./pluginConfig.vue?vue&type=style&index=1&id=4105b4b1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4105b4b1"]])

export default __exports__